<template>
  <v-layout row wrap>
    <v-flex xs12
      class="px-4 loan-input"
    >
      <expanding-input
        v-if="value !== '' && value !== '$0'"
        class="mt-4"
        id="loan-input"
        :label="title"
        ref="loanInput"
        :value="value"
        @input="updateValue(...arguments)"
        @focus="emitFocus"
        v-money="money"
        @blur="emitBlur"
        autofocus
      />
      <expanding-input
        v-else
        class="mt-4"
        id="loan-input"
        :label="title"
        ref="loanInput"
        value=""
        @input="updateValue(...arguments)"
        @focus="emitFocus"
        @blur="emitBlur"
        autofocus
      />
    </v-flex>
    <v-flex xs12
      class="mt-2"
      v-if="lender.id === 'marlin'"
    >
      <span
        v-show="showLoanError"
        class="red--text subheading"
      >
        Loan must be between {{ moneyValue(marlin.minLoanAmount) }} and {{ moneyValue(marlin.maxLoanAmount) }}
      </span>
    </v-flex>
    <v-flex xs12
      class="mt-2"
      v-else
    >
      <span
        v-show="showLoanError"
        class="red--text subheading"
      >
        Loan must be at least $1000
      </span>
    </v-flex>
  </v-layout>
</template>

<script>
  import ExpandingInput from 'Components/ExpandingInput.vue'
  import { mapState } from 'vuex'
  import { marlin } from 'Helpers/lenders.js'
  import { currency } from 'Helpers/utilFunctions.js'

  export default {
    name: 'LoanInput',
    components: {
      ExpandingInput
    },
    data () {
      return {
        money: {
          prefix: '$',
          precision: 0,
          thousands: ',',
          decimal: '.'
        },
        marlin,
      }
    },
    props: {
      title: {
        type: String,
        default: 'Enter Loan Amount'
      },
      showLoanError: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapState({
        lender: state => state.loanApplication.lender
      }),
    },
    methods: {
      emitBlur () {
        this.$emit('blur')
      },
      moneyValue(amount) {
        return currency(amount)
      },
      emitFocus () {
        this.$emit('focus')
      },
      updateValue (value) {
        this.$emit('input', value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .loan-wrapper {
    margin-top: 72px;
    margin-bottom: 72px;
  }

  .loan-input {
    font-size: 3em;
  }
</style>
